import { createContext, useState } from "react";
import { MergedColumnType } from "../../components/ui/table/utils/types";
import {
  DatepickerContextValue,
  DatepickerProviderProps,
  TableDataValue,
} from "./types";

export const DatepickerContext = createContext<DatepickerContextValue>({
  loading: false,
  setLoading: () => {},
  flag: false,
  setFlag: () => {},
  tableDataValue: [],
  setTableDataValue: () => {},
  onTableDataValueChange: () => {},
  isEmptyTable: () => false,
  refreshDatepickerContext: false,
  setRefreshDatepickerContext: () => {},
  // tableData: [],
  // setTableData: () => {},
  // rowData: null,
  // setrowData: () => {},
});

export function DatepickerProvider({ children }: DatepickerProviderProps) {
  const [refreshDatepickerContext, setRefreshDatepickerContext] =
    useState(false);
  const [loading, setLoading] = useState(false);
  const [flag, setFlag] = useState(false);
  const [tableDataValue, setTableDataValue] = useState<TableDataValue[]>([]);
  // const [tableData, setTableData] = useState<MergedColumnType[]>([]);
  // const [rowData, setrowData] = useState<MergedColumnType | null>(
  //   JSON.parse(sessionStorage.getItem("row_data") || "null")
  // );

  const onTableDataValueChange = (params: {
    url: string | undefined;
    tableData?: MergedColumnType[];
    rowData?: MergedColumnType | null;
  }) => {
    if (!params?.url) return;
    if (
      tableDataValue?.length > 0 &&
      tableDataValue.find((item) => item.url === params.url)
    ) {
      if (params?.tableData == null && params?.rowData == null) {
        setTableDataValue(
          tableDataValue.filter((item) => item.url !== params.url)
        );
        return;
      }
      setTableDataValue((prev) =>
        prev.map((item) =>
          item.url === params.url
            ? {
                ...item,
                ...(params.tableData != null
                  ? { tableData: params.tableData || [] }
                  : {}),
                ...(params.rowData != null
                  ? { rowData: params.rowData || null }
                  : {}),
              }
            : item
        )
      );
      return;
    } else {
      setTableDataValue([
        ...(tableDataValue || []),
        {
          url: params.url,
          tableData: params.tableData || [],
          ...(params.rowData != null
            ? { rowData: params.rowData || null }
            : {}),
        },
      ]);
    }
  };
// console.log('Table data value DATEPICKERPROVIDER ', tableDataValue);
  const isEmptyTable = (url: string) => {
    const tableData = tableDataValue.find(
      (item: any) => item.url === url
    )?.tableData;
    return !tableData?.length;
  };

  return (
    <DatepickerContext.Provider
      value={{
        loading,
        setLoading,
        flag,
        setFlag,
        tableDataValue,
        setTableDataValue,
        onTableDataValueChange,
        isEmptyTable,
        refreshDatepickerContext,
        setRefreshDatepickerContext,
        // tableData,
        // setTableData,
        // rowData,
        // setrowData,
      }}
    >
      {children}
    </DatepickerContext.Provider>
  );
}
